import React from 'react';

function paginas(pagina, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const itens = [1];
  const ini = Math.max(2, pagina - 1);
  const fim = Math.min(total - 1, pagina + 1);
  if (ini > 2) itens.push('…');
  for (let p = ini; p <= fim; p += 1) itens.push(p);
  if (fim < total - 1) itens.push('…');
  itens.push(total);
  return itens;
}

export default function Paginacao({ pagina, totalPaginas, onChange, totalItens, porPagina }) {
  if (totalPaginas <= 1) return null;

  const inicio = totalItens ? (pagina - 1) * (porPagina || 0) + 1 : null;
  const fim = totalItens ? Math.min(pagina * (porPagina || 0), totalItens) : null;

  return (
    <div className="sf-pagination">
      <span className="sf-pagination-info">
        {totalItens ? `Mostrando ${inicio}–${fim} de ${totalItens}` : `Página ${pagina} de ${totalPaginas}`}
      </span>
      <div className="sf-pagination-pages">
        <button
          type="button"
          className="sf-page-btn"
          disabled={pagina === 1}
          onClick={() => onChange(pagina - 1)}
          title="Página anterior"
          aria-label="Página anterior"
        >
          <i className="bi bi-chevron-left" />
        </button>
        {paginas(pagina, totalPaginas).map((p, i) =>
          p === '…' ? (
            <span key={`e${i}`} className="sf-page-ellipsis">…</span>
          ) : (
            <button
              key={p}
              type="button"
              className={`sf-page-btn ${p === pagina ? 'sf-page-btn-active' : ''}`}
              onClick={() => onChange(p)}
              aria-current={p === pagina ? 'page' : undefined}
              aria-label={`Página ${p}`}
            >
              {p}
            </button>
          )
        )}
        <button
          type="button"
          className="sf-page-btn"
          disabled={pagina === totalPaginas}
          onClick={() => onChange(pagina + 1)}
          title="Próxima página"
          aria-label="Próxima página"
        >
          <i className="bi bi-chevron-right" />
        </button>
      </div>
    </div>
  );
}
